export default __webpack_public_path__ + "static/media/sari (1).9e36687b.jpeg";